"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genTextareaStyle = exports.genFeedbackStyle = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var spaui_1 = require("@tencent/spaui");
var hook_1 = require("./hook");
var odc_text_1 = __importDefault(require("@tencent/odc-text"));
var odc_flex_1 = __importDefault(require("@tencent/odc-flex"));
var odc_pen_1 = __importDefault(require("@tencent/odc-pen"));
var util_1 = require("./util");
var FormGroupStyle = {
  marginTop: -2,
  marginBottom: -2
};
var usePopModeFormGroupStyle = {
  minWidth: '100%',
  width: 'fit-content'
};
var genFeedbackStyle = function genFeedbackStyle(useTextarea, inputHeight, restProps) {
  return useTextarea ? __assign({
    height: 20,
    lineHeight: '20px',
    top: inputHeight
  }, restProps) : __assign({}, restProps);
};
exports.genFeedbackStyle = genFeedbackStyle;
var genTextareaStyle = function genTextareaStyle(inputYGap, inputHeight) {
  return {
    padding: "".concat(inputYGap, "px 7px 0 11px"),
    height: inputHeight,
    fontSize: 12,
    lineHeight: '20px'
  };
};
exports.genTextareaStyle = genTextareaStyle;
var InstantTextComponent = function InstantTextComponent(props) {
  var disabled = props.disabled,
    disabledTips = props.disabledTips,
    _a = props.useTextarea,
    useTextarea = _a === void 0 ? false : _a,
    _b = props.usePopMode,
    usePopMode = _b === void 0 ? false : _b,
    maxLength = props.maxLength,
    _c = props.isNotFullWidthCharacter,
    isNotFullWidthCharacter = _c === void 0 ? false : _c,
    feedback = props.feedback,
    feedbackAddons = props.feedbackAddons,
    _d = props.feedbackStyle,
    feedbackStyle = _d === void 0 ? {} : _d,
    formGroupProps = props.formGroupProps,
    clear = props.clear,
    _e = props.inputHeight,
    inputHeight = _e === void 0 ? 80 : _e,
    _f = props.inputYGap,
    inputYGap = _f === void 0 ? 7 : _f,
    inputProps = props.inputProps,
    _g = props.size,
    size = _g === void 0 ? 'default' : _g,
    placeholder = props.placeholder,
    style = props.style,
    className = props.className,
    labelRender = props.labelRender,
    PenProps = props.PenProps,
    // eslint-disable-line
    TextProps = props.TextProps,
    // eslint-disable-line
    FlexProps = props.FlexProps;
  var _h = (0, hook_1.useInstantText)(props),
    value = _h.value,
    error = _h.error,
    status = _h.status,
    editable = _h.editable,
    formGroupRef = _h.formGroupRef,
    feedbackRef = _h.feedbackRef,
    feedbackHeight = _h.feedbackHeight,
    inputRef = _h.inputRef,
    handlePenClick = _h.handlePenClick,
    handleClear = _h.handleClear,
    handleInputChange = _h.handleInputChange,
    handleKeyPress = _h.handleKeyPress,
    handleTextareaChange = _h.handleTextareaChange;
  // 只读态的内容
  var readOnlyContent = react_1["default"].createElement(odc_flex_1["default"], __assign({
    inline: true,
    itemsCenter: true,
    className: (0, classnames_1["default"])('odc-instant-text instant-text', className)
  }, FlexProps), value ? react_1["default"].createElement(odc_text_1["default"], __assign({
    label: labelRender && (0, spaui_utils_1.isFunction)(labelRender) ? labelRender(value) : value
  }, TextProps)) : react_1["default"].createElement(odc_text_1["default"], {
    type: "comment",
    label: placeholder
  }), react_1["default"].createElement(odc_pen_1["default"], __assign({
    onClick: handlePenClick,
    iconClassName: (0, classnames_1["default"])({
      disabled: disabled
    }, PenProps === null || PenProps === void 0 ? void 0 : PenProps.iconClassName)
  }, PenProps)));
  var wrappedReadOnlyContent = disabledTips ? react_1["default"].createElement(spaui_1.OverlayTrigger, {
    placement: "top",
    overlay: react_1["default"].createElement(spaui_1.PopOver, null, disabledTips)
  }, readOnlyContent) : readOnlyContent;
  return !editable ? wrappedReadOnlyContent : react_1["default"].createElement("div", __assign({
    ref: formGroupRef
  }, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-instant-text instant-text', {
      'use-pop-mode': usePopMode
    }),
    supportAllEvents: true
  }, InstantTextComponent), {
    style: style
  }), react_1["default"].createElement(spaui_1.FormGroup, __assign({
    className: (0, classnames_1["default"])({
      'has-textarea': useTextarea
    }, 'no-margin', "has-size-".concat(size)),
    error: error,
    status: status,
    feedback: react_1["default"].createElement("span", {
      ref: feedbackRef
    }, maxLength ? react_1["default"].createElement("span", {
      className: "spaui-input-feedback-group"
    }, react_1["default"].createElement("span", {
      className: "spaui-input-feedback-count"
    }, isNotFullWidthCharacter === true ? value.length : (0, util_1.getFullWidthCharacterStrLength)(value)), react_1["default"].createElement("span", {
      className: "spaui-input-feedback-divider"
    }, "/"), react_1["default"].createElement("span", {
      className: "spaui-input-feedback-range"
    }, maxLength)) : null, feedback, feedbackAddons),
    feedbackStyle: (0, exports.genFeedbackStyle)(useTextarea, inputHeight, feedbackStyle),
    feedbackClassName: (0, classnames_1["default"])('instant-text-feedback', {
      'w-full left-0 right-0 flex items-center justify-end': useTextarea
    }),
    feedbackSpace: 10,
    style: usePopMode ? usePopModeFormGroupStyle : FormGroupStyle,
    clear: clear,
    onClear: handleClear
  }, formGroupProps), !useTextarea ? react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(spaui_1.Input, __assign({
    placeholder: placeholder,
    size: size,
    value: value,
    onChange: handleInputChange,
    onKeyPress: handleKeyPress,
    ref: inputRef
  }, inputProps)), react_1["default"].createElement("div", {
    style: {
      whiteSpace: 'nowrap',
      padding: '0 12px',
      paddingRight: 'var(--feedback-width,54px)',
      height: 0,
      opacity: 0
    }
  }, value)) : react_1["default"].createElement("div", {
    className: "spaui-input as-textarea within-border-brand",
    style: {
      padding: 0,
      height: inputHeight + inputYGap + feedbackHeight
    }
  }, react_1["default"].createElement("textarea", __assign({}, inputProps, {
    className: "w-full radius-6 radius-b-none",
    style: (0, exports.genTextareaStyle)(inputYGap, inputHeight),
    onChange: handleTextareaChange,
    value: value,
    ref: inputRef
  })))));
};
(0, spaui_utils_1.setComponentMark)(InstantTextComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(InstantTextComponent);